<template>
  <div class="present-photo">
    <img
      class="present-photo__stretcher"
      src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII="
    >
    <ul
      v-if="products.length > 0"
      class="present-photo__products"
    >
      <li
        v-for="(product, index) in products.slice(0, products.length === 4 ? 4 : 3)"
        :key="index"
        class="present-photo__product"
      >
        <img :src="product.photos[$store.getters.groupAbb][0].sd" :alt="product.name">
      </li>

      <li
        v-if="products.length > 4"
        class="present-photo__product --has-more"
      >
        <p><b>+ {{ products.length - 3 }} </b> <small>Delikatessen</small></p>

        <div class="--has-fade">
          <img
            v-for="(product, index) in products.slice(3, products.length)"
            :key="index"
            :src="product.photos[$store.getters.groupAbb][0].sd"
            :alt="product.name"
          >
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'PresentPhotoVirtual',
  props: {
    products: {
      default: []
    }
  },
  components: {
  }
};
</script>

<style lang="scss" scoped>
/**
 * Present Photo Virtual
 *
 * @author juanpablob <m.juanpablob@gmail.com>
 * @desc Used for feature included products of a present box that doesn't have an image
 * @since 2021-10-18
**/

$component: 'present-photo';

.#{$component} {
  position: relative;
  width: 100%;
  aspect-ratio: 1 / 1;

  &__stretcher {
    width: 100%;
    height: 100%;
  }

  &__products {
    @include unlist;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    display: flex;
    flex-wrap: wrap;
  }

  &__product {
    flex: 0 0 48%;
    background-color: $white;

    &:nth-child(odd) {
      margin-right: 4%;
    }

    &:not(:nth-child(-n+2)) {
      margin-top: 4%;
    }

    img {
      display: block;
      width: 100%;
      height: auto;
      @include padding(map-get($spacers, 2));
      border: 1px solid $gray-ghost;
      border-radius: $border-radius-lg;
    }

    &.--has-more {
      display: flex;
      align-items: center;
      justify-content: space-around;
      flex-direction: column;
      overflow: hidden;
      @include padding(map-get($spacers, 2));
      border: 1px solid $gray-ghost;
      border-radius: $border-radius-lg;
      color: $ink-lighter;
      @include font-size($font-size-lg);

      p {
        margin: 0;
        text-align: center;
      }

      small {
        display: block;
        width: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        text-align: center;
      }

      > div {
        position: relative;
        display: flex;
        width: 100%;
        flex-wrap: nowrap;
        justify-content: space-around;
        @include margin-top(map-get($spacers, 3));

        &:before,
        &:after {
          content: '';
          position: absolute;
          top: 0;
          display: block;
          @include rfs(3rem, width);
          height: 110%;
          @include linear-gradient(to right, $white, transparent);
          pointer-events: none;
        }

        &:before {
          @include rfs(- map-get($spacers, 2), left);
        }

        &:after {
          @include rfs(- map-get($spacers, 2), right);
          transform: rotate(180deg);
        }

        img {
          padding: 0;
          border: 0;
          @include rfs(1.4rem, width);
        }
      }
    }
  }

  /** RESPONSIVENESS **/

  // ——————————————————————————————
  // Max LG
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-lg')) {
  }

  // ——————————————————————————————
  // Max MD
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-md')) {
  }

  // ——————————————————————————————
  // Max SM
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-sm')) {
  }

  // ——————————————————————————————
  // Max XS
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-xs')) {
  }
}
</style>
